import { render, staticRenderFns } from "./ArtigosCalendar.vue?vue&type=template&id=62d2907b&scoped=true&"
import script from "./ArtigosCalendar.vue?vue&type=script&lang=js&"
export * from "./ArtigosCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosCalendar.vue?vue&type=style&index=0&id=62d2907b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2907b",
  null
  
)

export default component.exports